// extracted by mini-css-extract-plugin
export default {"codeBlock":"TextArea_codeBlock__YQ3vA"};